import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import Helmet from 'react-helmet';
import RaisedButton from 'material-ui/RaisedButton';
import Dropzone from 'react-dropzone';
import { Spinner } from 'components';
import * as styles from './ImagePicker.scss';

function ImagePickerUpload(props) {
  var organization = props.organization,
      fileUploadError = props.fileUploadError,
      handleImages = props.handleImages,
      images = props.images,
      maxImageCount = props.maxImageCount,
      uploadImages = props.uploadImages,
      uploadingImage = props.uploadingImage;

  var onDropFunc = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(files) {
      var gifFile, uploadFiles, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(files && files.length > 0)) {
                _context.next = 13;
                break;
              }

              gifFile = files.find(function (f) {
                return f.type === 'image/gif';
              });

              if (!(images && images.length > 0 && gifFile)) {
                _context.next = 6;
                break;
              }

              console.error('Cannot add GIF. Images already uploaded.');
              alert('Only a single GIF image is supported in a post. Please remove any other uploaded images and try again.');
              return _context.abrupt("return");

            case 6:
              uploadFiles = gifFile ? [gifFile] : files;

              if (files.length > maxImageCount) {
                uploadFiles = files.slice(0, maxImageCount);
              }

              _context.next = 10;
              return uploadImages(uploadFiles, organization.id);

            case 10:
              res = _context.sent;
              props.parentImageHandler(res.data);
              props.resetState();

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onDropFunc(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrap
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrap
  }, !uploadingImage && /*#__PURE__*/React.createElement(Dropzone, {
    multiple: maxImageCount > 1,
    onDrop: onDropFunc,
    accept: 'image/*',
    style: {
      width: '100%',
      height: 320,
      borderColor: '#8b8b8b',
      borderRadius: 4,
      border: '2px dashed #8b8b8b',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: '#8b8b8b',
      fontSize: 26
    }
  }, "Drag images here"), /*#__PURE__*/React.createElement("div", {
    style: {
      color: '#8b8b8b',
      fontSize: 18,
      marginTop: 16
    }
  }, "Or"), /*#__PURE__*/React.createElement(RaisedButton, {
    secondary: true,
    label: "Choose Images To Upload",
    style: {
      marginTop: 16
    }
  })), uploadingImage && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      height: 320,
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Spinner, {
    center: true
  })), fileUploadError ? /*#__PURE__*/React.createElement("p", {
    style: {
      color: 'red'
    }
  }, this.props.fileUploadError) : null));
}

export default ImagePickerUpload;